import React, { useState, useEffect, useRef, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridColumnMenu, useGridApiRef, gridFilteredSortedRowIdsSelector, GRID_CHECKBOX_SELECTION_COL_DEF, gridFilterableColumnLookupSelector, GridFooter } from '@mui/x-data-grid-pro';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from '@mui/material/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { BsPersonSquare } from 'react-icons/bs';
import { formatPhone } from '../../common/utils';
import { ToastContainer } from 'react-toastify';
import AddToGroup from '../../components/Modals/AddToGroup';
import AddEvent from '../../components/Modals/AddEvent';
import SendMassTxt from '../../components/Modals/SendMassTxt';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import LaunchPhoneBurner from '../../components/Modals/LaunchPhoneBurner';
import { ModalCtx } from '../../contexts';
import { singleSelectQuickFilter } from '../../common/utils';
import { update } from '../../common/api';
import NamesInGrid from './NamesInGrid';
import NoteInGrid from './NoteInGrid';
import TaskInGrid from './TaskInGrid';
import Toolbar from './toolbar';


import "react-toastify/dist/ReactToastify.css";


function useQuery() {
    return new URLSearchParams( useLocation().search );
}

const customColumnMenu = ( props ) => {
    return (
        <GridColumnMenu
            { ...props }
            slots={ {
                columnMenuColumnsItem: null,
                columnMenuPinningItem: null
            } }
        />
    );
}

const Nurtures = ( { orgId, aid, uid, user, grids, viewing, canExport, stack, contacts, opps, lists, notes, tasks, loans, status, setDatagridWidth, setDatagridOrder } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [show, setShow] = useState(false);
    const closeModal = () => setShow(false);
    const openModal = () => setShow(true);
    const [ modal, setModal ] = useState();
    const [ loading, setLoading ] = useState( true );
    const [ nurtures, setNurtures ] = useState( [] );
    const [ hasPhoneBurner, setHasPhoneBurner ] = useState( false );
    const [ hasTxting, setHasTxting ] = useState( false );
    const [ cols, setCols ] = useState( [] );
    const [ gridReady, setGridReady ] = useState( false );
    const [ filterModel, setFilterModel ] = useState( { items: [] } );
    const [ q, setQ ] = useState( '' );
    const [ classLogic, setClassLogic ] = useState( '' );
    const [ usingFilter, setUsingFilter ] = useState( false );
    const [ filterName, setFilterName ] = useState( '' );

    const query = useQuery();

    const location = useLocation();

    const containerRef = useRef();
    const titleRef = useRef();
    
    const gridRef = useGridApiRef();

    const handleColumnWidthChange = async ( { colDef, width } ) => {
        const datagrid = 'nurtures';

        let newWidths = {};
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newWidths[col.field] = col.width;
            }
        } );
        setDatagridWidth( { grid: datagrid, values: newWidths, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-width', uid, {
            grid: datagrid,
            values: newWidths,
            fn: filterName
        } );
    }

    const handleColumnOrderChange = async ( params ) => {
        const datagrid = 'nurtures';

        const newOrder = [];
        gridRef.current.getAllColumns().forEach( col => {
            if ( ![ '__check__', 'actions' ].includes( col.field ) ) {
                newOrder.push( col.field );
            }
        } );
        setDatagridOrder( { grid: datagrid, values: newOrder, fn: filterName } );
        await update( orgId, aid, uid, 'datagrid-order', uid, {
            grid: datagrid,
            values: newOrder,
            fn: filterName
        } );
    }

    const formatName = ( cid ) => {
        const r = contacts[cid]; // cl.find( f => f.cid === cid );
        return ( r ) ? `${r.firstname} ${r.lastname}` : null;
    };
    
    const gridHelpers = {
        valueGetter: {
            contact: ( { row } ) => {
                return formatName( row.cid );
            },
            referral: ( { row } ) => {
                return formatName( row.referredById );
            },
            phone: ( { row } ) => {
                let p;  
                const c = contacts[row.cid];
                if ( c && c.phoneMobile && c.phoneMobile.length ) {
                    p = c.phoneMobile;
                } else if ( c && c.phone && c.phone.length ) {
                    p = c.phone;
                }
                return ( p ) ? formatPhone( p ) : null;
            },
            email: ( { row } ) => {
                let e;
                const c = contacts[row.cid];
                if ( c && c.email && c.email.length ) {
                    e = c.email;
                }
                return ( e ) ? e : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = new Date( value.match( 'T' ) ? value : value + 'T12:00:00' );
                    // d.setDate( d.getDate() + 1 );
                }
                return ( d ) ? d : null;
            },
            groups: ( { row } ) => {
                const ships = [];
                Object.keys( lists ).forEach( gid => {
                    const l = lists[gid];
                    if ( l && l.cids && l.cids.includes( row.cid ) ) {
                        ships.push( l );
                    }
                } );
                return ships;
            },
            latestClosedTask: ( { row } ) => {
                const tmpTasks = [];
                Object.keys( tasks ).forEach( tid => {
                    const t = tasks[tid];
                    if ( t.status === 'Open' ) {
                        return;
                    }
                    const yes = t.assoc?.find( f => f.cid === row.cid );
                    if ( yes ) {
                        tmpTasks.push( t );
                    }
                } );
                tmpTasks.sort( ( a, b ) => {
                    const ad = new Date( a.completedDate ? a.completedDate : a.createdDate );
                    const bd = new Date( b.completedDate ? b.completedDate : b.createdDate );
                    return bd.getTime() - ad.getTime();
                } );
                return ( tmpTasks.length ) ? tmpTasks[0] : null;
                // return row.lastTask;
            },
            latestNote: ( { row } ) => {
                const tmpNotes = [];
                Object.keys( notes ).forEach( nid => {
                    const n = notes[nid];
                    const yes = n.assoc?.find( f => f.cid === row.cid );
                    if ( yes ) {
                        tmpNotes.push( n );
                    }
                } );
                tmpNotes.sort( ( a, b ) => {
                    const ad = new Date( a.createdDate );
                    const bd = new Date( b.createdDate );
                    return bd.getTime() - ad.getTime();
                } );
                return ( tmpNotes.length ) ? tmpNotes[0] : null;
                // return row.lastNote;
            }
        },
        renderCell: {
            phone: ( { value } ) => {
                return ( value ) ? <a href={`tel:${value}`}>{value}</a> : null;
            },
            email: ( { value } ) => {
                return ( value ) ? <a href={`mailto:${value}`}>{value}</a> : null;
            },
            date: ( { value } ) => {
                let d;
                if ( value ) {
                    d = value.toLocaleDateString();
                }
                return d;
            },
            contact: ( { row } ) => {
                return <NamesInGrid row={row} />
                // let l;
                // if ( row && row.cid ) {
                //     const c = contacts[row.cid];
                //     if ( c ) {
                //         l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                //     }
                // }
                // return l;
            },
            referral: ( { row } ) => {
                let l;
                if ( row && row.referredById ) {
                    const c = contacts[row.referredById];
                    if ( c ) {
                        l = <Link to={`/contact/${c.cid}`}>{ formatName( c.cid ) }</Link>
                    }
                }
                return l;
            },
            groups: ( { value } ) => {
                // return ( value && value.length ) ? value.map( m => <Link to={`/list/${m.gid}`}>{m.label}</Link> ).join( ', ' ) : null;
                return ( value && value.length ) ? value.map( m => m.label ).join( ', ' ) : null; 
            },
            latestClosedTask: ( { value } ) => {
                return <TaskInGrid task={value} />;
            },
            latestNote: ( { value } ) => {
                return <NoteInGrid note={value} />;
            },
            fileNum: ( { row } ) => {
                return ( row.lid && row.fileNum ) ? <Link to={`/loan/${row.lid}`}>{row.fileNum}</Link> : null;
            }
        },
        valueFormatter: {
            phone: ( { value } ) => {
                return ( value ) ? value : null;
            },
            email: ( { value } ) => {
                return ( value ) ? value : null;
            },
            date: ( { value } ) => {
                return ( value ) ? value.toLocaleDateString() : null;
            },
            contact: ( { value } ) => {
                return ( value ) ? value : '';
            },
            referral: ( { value } ) => {
                return ( value ) ? value : '';
            },
            groups: ( { value } ) => {
                return ( value && value.length ) ? value.map( m => m.label ).join( ', ' ) : null; 
            },
            latestClosedTask: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            },
            latestNote: ( { value } ) => {
                return ( value && value.name ) ? value.name : null;
            }
        },
        getApplyQuickFilterFn: {
            singleSelectQuickFilter: singleSelectQuickFilter
        }
    };
  
    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    const handleModal = ( t ) => {
        let shouldOpen = true;

        const list = [];
        const loids = [];
        const allCids = [];
        const emailCids = [];
        const phoneCids = [];
        const uniqueEmails = new Set();
        const uniquePhones = new Set();
        selectedRows.forEach( r => {
            const [ loid, cid ] = r.split( '#' );
            loids.push( loid );
            const c = contacts[cid];
            if ( c ) {
                list.push( c );
                allCids.push( cid );
                if ( c.email && c.email.length ) {
                    if ( !uniqueEmails.has( c.email.toLowerCase() ) && c.optoutEmail !== true ) {
                        uniqueEmails.add( c.email.toLowerCase() );
                        emailCids.push( cid );
                    }
                }
                let p = c.phoneMobile || c.phone || c.phoneWork || c.phoneHome;
                if ( p && p.length ) {
                    p = formatPhone( p );
                    if ( !uniquePhones.has( p ) && c.optoutSms !== true ) {
                        uniquePhones.add( p );
                        phoneCids.push( cid );
                    }
                }
            }
        } );
                
        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail close={closeModal} clist={emailCids} objType='contact' aid={viewing[0]} /> );
                break;

            case 'sms-mass':
                setModal( <SendMassTxt close={closeModal} clist={phoneCids} objType='contact' /> );
                break;

            case 'list':
                setModal( <AddToGroup close={closeModal} itemType='contacts' items={allCids} aid={viewing[0]} /> );
                break;
    
            case 'event':
                setModal( <AddEvent close={closeModal} contacts={allCids} /> );
                break;

            case 'phoneburner':
                setModal( <LaunchPhoneBurner close={closeModal} type='leads' data={loids} /> );
                break;
    
            default:
                shouldOpen = false;
                console.log( 'Unknown modal type: ' + t );
        }

        if ( shouldOpen ) {
            openModal();
        }
    }
    
    const getRowClassName = ( params ) => {
        let cn = '';
        // console.log( classLogic );
        if ( classLogic ) {
            eval( classLogic );
        }
        return cn;
    }
    
    useEffect(() => {
        document.title = 'Third Floor - Nurtures';
    }, [] );

    useEffect( () => {
        let filters = {};
        for ( let [ key, value ] of query.entries() ) {
            filters[key] = value;
        }

        if ( grids && grids.nurtures && grids.nurtures.cols && !gridReady ) {
            let activeFilter = false;
            setFilterName( '' );

            let storedCols = JSON.parse( grids.nurtures.cols );
            if ( filters.fn && grids.nurtures.filters && grids.nurtures.filters[filters.fn] ) {
                if ( grids.nurtures.filters[filters.fn].cols ) {
                    activeFilter = true;
                    setUsingFilter( true );
                    setFilterName( filters.fn );
                    storedCols = JSON.parse( grids.nurtures.filters[filters.fn].cols );
                }

                if ( grids.nurtures.filters[filters.fn].criteria ) {
                    const crit = JSON.parse( grids.nurtures.filters[filters.fn].criteria );
                    setFilterModel( { items: crit } );
                }

                if ( grids.nurtures.filters[filters.fn].className ) {
                    setClassLogic( grids.nurtures.filters[filters.fn].className );
                }
            } else {
                if ( filters.crit ) {
                    const crit = JSON.parse( filters.crit );
                    setFilterModel( { items: crit } );
                }
                if ( grids.nurtures.className ) {
                    setClassLogic( grids.nurtures.className );
                }
            }

            if ( storedCols ) {
                let cols = storedCols.map( c => {
                    if ( c.renderCell && gridHelpers.renderCell[c.renderCell] ) {
                        c.renderCell = gridHelpers.renderCell[c.renderCell];
                    }
                    if ( c.valueGetter && gridHelpers.valueGetter[c.valueGetter] ) {
                        c.valueGetter = gridHelpers.valueGetter[c.valueGetter];
                    }
                    if ( c.valueFormatter && gridHelpers.valueFormatter[c.valueFormatter] ) {
                        c.valueFormatter = gridHelpers.valueFormatter[c.valueFormatter];
                    }
                    if ( c.getApplyQuickFilterFn && gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn] ) {
                        c.getApplyQuickFilterFn = gridHelpers.getApplyQuickFilterFn[c.getApplyQuickFilterFn];
                    }

                    if ( user && user.datagrids && user.datagrids.nurtures ) {
                        if ( activeFilter ) {
                            if ( user.datagrids.nurtures.filters && user.datagrids.nurtures.filters[filters.fn] && user.datagrids.nurtures.filters[filters.fn].colSize && user.datagrids.nurtures.filters[filters.fn].colSize[c.field] ) {
                                c.width = user.datagrids.nurtures.filters[filters.fn].colSize[c.field];
                            }
                        } else if ( user.datagrids.nurtures.colSize && user.datagrids.nurtures.colSize[c.field] ) {
                            c.width = user.datagrids.nurtures.colSize[c.field];
                        }
                    }

                    return c;
                } );

                if ( user && user.datagrids && user.datagrids.nurtures ) {
                    if ( activeFilter ) {
                        if ( user.datagrids.nurtures.filters && user.datagrids.nurtures.filters[filters.fn] && user.datagrids.nurtures.filters[filters.fn].colOrder && user.datagrids.nurtures.filters[filters.fn].colOrder.length ) {
                            cols = user.datagrids.nurtures.filters[filters.fn].colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    } else {
                        if ( user.datagrids.nurtures.colOrder && user.datagrids.nurtures.colOrder.length ) {
                            cols = user.datagrids.nurtures.colOrder.map( field => {
                                return storedCols.find( f => f.field === field );
                            } );
                        }
                    }
                }

                setCols( cols );
                setGridReady( true );
            }
        }
    }, [ user, query, grids, gridHelpers.renderCell, gridHelpers.valueGetter, gridHelpers.valueFormatter, gridHelpers.getApplyQuickFilterFn, gridReady ] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( opps ) {
            const stats = status.filter( s => s.queue === 'nurture' ).map( m => m.value );
            let list = [];
            Object.keys( opps ).forEach( o => {
                if ( stats.includes( opps[o].status ) ) {
                    const lor = opps[o].relationships[0]
                    
                    if ( lor ) {
                        const c = contacts[lor.cid];
                        if ( c && viewing.includes( c.aid ) ) {
                            const tmpNotes = [];
                            const tmpTasks = [];
                            let fileNum;
                            let loanSource;

                            if ( lor.lid ) {
                                const l = loans[lor.lid];
                                if ( l && l.fileNum ) {
                                    fileNum = l.fileNum;
                                    loanSource = l.source;
                                }
                            }
                            Object.keys( notes ).forEach( nid => {
                                const n = notes[nid];
                                const yes = n.assoc?.find( f => f.cid === c.cid );
                                if ( yes ) {
                                    tmpNotes.push( n );
                                }
                            } );
                            tmpNotes.sort( ( a, b ) => {
                                const ad = new Date( a.createdDate );
                                const bd = new Date( b.createdDate );
                                return bd.getTime() - ad.getTime();
                            } );

                            Object.keys( tasks ).forEach( tid => {
                                const t = tasks[tid];
                                if ( t.status !== 'Completed' ) {
                                    return;
                                }
                                const yes = t.assoc?.find( f => f.cid === c.cid );
                                if ( yes ) {
                                    tmpTasks.push( t );
                                }
                            } );
                            tmpTasks.sort( ( a, b ) => {
                                const ad = new Date( a.completedDate ? a.completedDate : a.createdDate );
                                const bd = new Date( b.completedDate ? b.completedDate : b.createdDate );
                                return bd.getTime() - ad.getTime();
                            } );

                            list.push( {
                                ...contacts[lor.cid],
                                ...lor,
                                ...opps[o],
                                oppsName: opps[o].name,
                                id: lor.lorid,
                                lastTask: tmpTasks[0],
                                lastNote: tmpNotes[0],
                                fileNum: fileNum,
                                loanSource: loanSource
                            } );
                        }
                    }
                }
            } );
            list.sort( ( a, b ) => {
                const ad = new Date( a.oppDate );
                const bd = new Date( b.oppDate );

                if ( !ad ) {
                    return 1;
                }
                if ( !bd ) {
                    return -1;
                }
                return bd.getTime() - ad.getTime();
            } );

            setNurtures( list );
            setLoading( false );
        }
    }, [ opps, contacts, loans, notes, tasks, status, aid, uid, viewing ] );

    useEffect(() => {
        if ( location.search !== q ) {
            setGridReady( false );
            setFilterModel( { items: [] } );
            setClassLogic( '' );
            setQ( location.search );
        }
    }, [ location.search, q ] ); 

    useEffect( () => {
        if ( stack ) {
            if ( stack.dialer && stack.dialer.type === 'PhoneBurner' ) {
                setHasPhoneBurner( true );
            }
            if ( stack.sms && stack.sms ) {
                setHasTxting( true );
            }
        }
    }, [ stack ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='tf-page-container' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='p-0' style={ { height: '100%' } }>
                    <Card style={ { height: '100%' } }>
                        <Card.Body className='py-0'>
                            <Card.Title className='pt-1' ref={titleRef}>
                                <Row>
                                    <Col>
                                        <BsPersonSquare />
                                        <span className='ps-2 fw-bold fs-6'>Nurtures</span>
                                    </Col>
                                </Row>
                            </Card.Title>
                            <Row>
                                <Col style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ModalCtx.Provider value={ { openModal, closeModal, setModal } }>
                                        {
                                            ( gridReady ) ? (
                                                <DataGridPro
                                                    apiRef={gridRef}
                                                    initialState={ { 
                                                        pinnedColumns: { left: [ GRID_CHECKBOX_SELECTION_COL_DEF.field, 'name' ] }
                                                    } }
                                                    loading={ loading }
                                                    rows={nurtures}
                                                    columns={cols}
                                                    density='compact'
                                                    checkboxSelection
                                                    disableSelectionOnClick
                                                    slots={ { 
                                                        toolbar: Toolbar,
                                                        columnMenu: customColumnMenu 
                                                    } }
                                                    slotProps={ { toolbar: {
                                                        selectedRows: selectedRows, 
                                                        handleModal: handleModal, 
                                                        hasTxting: hasTxting, 
                                                        hasPhoneBurner: hasPhoneBurner, 
                                                        canExport: canExport,
                                                        viewing: viewing
                                                    } } }
                                                    onColumnWidthChange={ handleColumnWidthChange }
                                                    onColumnOrderChange={ handleColumnOrderChange }
                                                    onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                                    filterModel={ filterModel }
                                                    onFilterModelChange={ ( newFilterModel ) => setFilterModel( newFilterModel ) }
                                                    getRowClassName={ getRowClassName }
                                                    editMode='row'
                                                />
                                            ) : (
                                                null
                                            )
                                        }
                                    </ModalCtx.Provider>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal open={show} onClose={closeModal}>
                <Fragment>{modal}</Fragment>
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) =>( {
    orgId: state.user.orgId,
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    grids: state.user.meta.datagrids,
    viewing: state.user.viewing,
    canExport: state.user.canExport,
    stack: state.user.stack,
    contacts: state.contacts.byId,
    opps: state.leadopps.byId,
    lists: state.lists.byId,
    notes: state.notes.byId,
    tasks: state.tasks.byId,
    loans: state.loans.byId,
    status: state.user.meta.global.picklist.status,
} );

const mapDispatch = ( dispatch ) => ( {
    setDatagridWidth: dispatch.user.setDatagridWidth,
    setDatagridOrder: dispatch.user.setDatagridOrder
} );

export default connect( mapProps, mapDispatch )( Nurtures );